// @flow

export const DEFAULT_STATUS_TIMEOUT = 60000;

export const LOAD_CONFIG: 'CONFIG.LOAD_CONFIG' = 'CONFIG.LOAD_CONFIG';
export const SET_CONFIG: 'CONFIG.SET_CONFIG' = 'CONFIG.SET_CONFIG';
export const UNSET_CONFIG: 'CONFIG.UNSET_CONFIG' = 'CONFIG.UNSET_CONFIG';

export const PREVIEW_MAP_SOURCE: 'CONFIG.PREVIEW_MAP_SOURCE' = 'CONFIG.PREVIEW_MAP_SOURCE';